module.exports = __webpack_public_path__ + "img/监视设备.797f8b19.gif";